import api from './api';

export const getFolders = async (params = {}) => {
  const response = await api.get('/folders', { params });
  return response.data;
};

export const getFolder = async (id) => {
  const response = await api.get(`/folders/${id}`);
  return response.data;
};

export const createFolder = async (folderData) => {
  const response = await api.post('/folders', folderData);
  return response.data;
};

export const updateFolder = async (id, folderData) => {
  const response = await api.put(`/folders/${id}`, folderData);
  return response.data;
};

export const deleteFolder = async (id) => {
  const response = await api.delete(`/folders/${id}`);
  return response.data;
};

export const getFolderHierarchy = async (categoryId) => {
  const response = await api.get(`/folders/hierarchy/${categoryId}`);
  return response.data;
};